import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetAllPR_InformationWebsiteByPR_ReportsStagesGuid =
  createAsyncThunk(
    "InformationWebsite/GetAllPR_InformationWebsiteByPR_ReportsStagesGuid",
    async (reportsStagesGuid, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/InformationWebsite/GetAllPR_InformationWebsiteByPR_ReportsStagesGuid",
          reportsStagesGuid
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const UpdatePR_InformationWebsite = createAsyncThunk(
  "InformationWebsite/UpdatePR_InformationWebsite",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationWebsite/UpdatePR_InformationWebsite",
        {
          pR_InformationWebsiteId: update.pR_InformationWebsiteId,
          pR_InformationWebsiteNameId: update.pR_InformationWebsiteNameId,
          number: update.number,
          pR_ReportsStagesGuid: update.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteInformationWebsite = createAsyncThunk(
  "GetSpecificRowNoteInformationWebsitedddd/GetSpecificRowNoteInformationWebsite",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"aaaadaaa"); 

      // return data.filter((item) => item.incrementNumber - 1 === 1);
      return data
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const InformationWebsite = createSlice({
  name: "InformationWebsite",
  initialState: {
    InformationWebsiteInfo: [],
    loadingInformationWebsiteInfo: false,
    errorInformationWebsiteInfo: null,
    //----------------------- update -------------------------------------
    UpdateInformationWebsiteInfo: [],
    loadingUpdateInformationWebsiteInfo: false,
    errorUpdateInformationWebsiteInfo: null,
    //-------------------------------------- get specific row note ---------------------------------------

    OneSpecificRowNoteInformationWebsite: {},
    loadingOneSpecificRowNoteInformationWebsite: false,
    errorOneSpecificRowNoteInformationWebsite: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetAllPR_InformationWebsiteByPR_ReportsStagesGuid.pending,
        (state, action) => {
          state.loadingInformationWebsiteInfo = true;
          state.InformationWebsiteInfo = action.payload;
          state.errorInformationWebsiteInfo = null;
        }
      )
      .addCase(
        GetAllPR_InformationWebsiteByPR_ReportsStagesGuid.fulfilled,
        (state, action) => {
          state.loadingInformationWebsiteInfo = false;
          state.InformationWebsiteInfo = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllPR_InformationWebsiteByPR_ReportsStagesGuid.rejected,
        (state, action) => {
          state.loadingInformationWebsiteInfo = false;
          state.InformationWebsiteInfo = action.payload;
        }
      )
      //-------------------------------------- update ---------------------------------------
      .addCase(UpdatePR_InformationWebsite.pending, (state, action) => {
        state.loadingUpdateInformationWebsiteInfo = true;
        state.UpdateInformationWebsiteInfo = action.payload;
        state.errorUpdateInformationWebsiteInfo = null;
      })
      .addCase(UpdatePR_InformationWebsite.fulfilled, (state, action) => {
        state.loadingUpdateInformationWebsiteInfo = false;
        state.UpdateInformationWebsiteInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdatePR_InformationWebsite.rejected, (state, action) => {
        state.loadingUpdateInformationWebsiteInfo = false;
        state.UpdateInformationWebsiteInfo = action.payload;
      })
      //-------------------------------------- get specific row note ---------------------------------------
      .addCase(
        GetSpecificRowNoteInformationWebsite.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteInformationWebsite = true;
          state.OneSpecificRowNoteInformationWebsite = action.payload;
          state.errorOneSpecificRowNoteInformationWebsite = null;
        }
      )
      .addCase(
        GetSpecificRowNoteInformationWebsite.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteInformationWebsite = false;
          state.OneSpecificRowNoteInformationWebsite = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteInformationWebsite.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteInformationWebsite = false;
          state.errorOneSpecificRowNoteInformationWebsite = action.payload;
        }
      );
  },
});

export default InformationWebsite.reducer;
